// Vue
import { Component } from "vue-property-decorator";
// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";

import { ImageAspectRatio } from "#/components/image_aspect_ratio/ImageAspectRatio";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
  },
})
export class CwTextBildModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  get getColorClass() {
    let color = this.instance["section_text"]["color"];
    return color == "white" ? "white" : "black";
  }

  public isVideo(image) {
    return (
      image["video"] &&
      image["video"] != "" &&
      (image["video"]["embedUrl"] || image["video"]["uploadUrl"])
    );
  }

  public isImage(imageObject) {
    /* console.log(
      imageObject,
      this.getTranslatedImage(imageObject, this.lang, "full")
    ); */
    return this.getTranslatedImage(imageObject, this.lang, "full");
  }

  get numberOfImages() {
    let count = 0;

    this.instance["images"].forEach(() => {
      count++;
    });

    return count;
  }

  get columnSize() {
    switch (this.instance["layout"]) {
      case "wb-col-mq1-9":
        return 9;
      case "wb-col-mq1-12":
        return 12;
      default:
        return 12;
    }
  }

  get getHeadlineSize() {
    switch (this.instance["headline"]["type"]) {
      case "h1":
        return 1;
      case "h2":
        return 2;
      case "h3":
        return 3;
      case "subline":
        return 4;
      default:
        return 1;
    }
  }
}
